export default __webpack_public_path__ + "static/media/Annons 2.ae8ba821.jpg";